export const appointmentStatus3POnly = {
  REQUESTED: 'Requested',
  REQUEST_DECLINED: 'Request declined',
  CHECKED_IN: 'Checked in',
  ALL_CHARGES_IN: 'All charges in',
  IN_PROGRESS: 'In progress',
}
